import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const JobTitle = (props: InputComponentProps) => {
  const validate = ({ value }) => {
    const regex = /^[a-zA-ZÀ-ÖØ-öø-ÿ' -]+$/;
    if (value.trim().length < 1) return 'Please enter your job title';
    if (!regex.test(value.trim())) return 'Please enter a valid job title';

    return true;
  };

  return (
    <ValidatingInput
      autoComplete="job-title"
      label="Job title"
      name="jobTitle"
      placeholder="Job title"
      maxLength={32}
      validate={validate}
      {...props}
    />
  );
};
